module.exports = __webpack_public_path__ + "img/panel-time.4085ac86.svg";